<template>
  <div class="w-100">
    Job's "Referred By" manually changed from
    <user-object
      v-if="$lodash.has(activity, 'detail.oldJob.referred_by.id')"
      :entity-id="$lodash.get(activity, 'detail.oldJob.referred_by.id')"
      :name="$lodash.get(activity, 'detail.oldJob.referred_by.name')"
      :open-new="true"
    />
    <user-object v-else :entity-id="0" name="NO ONE" />

    to
    <user-object
      v-if="$lodash.has(activity, 'detail.job.referred_by.id')"
      :entity-id="$lodash.get(activity, 'detail.job.referred_by.id')"
      :name="$lodash.get(activity, 'detail.job.referred_by.name')"
      :open-new="true"
    />
    <user-object v-else :entity-id="0" name="NO ONE" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
